import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";

const emptyInfo = {
  phone: "",
  currentRole: "",
  experienceLevel: "",
  targetPosition: ""
};

const UserAdmin = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const res = await api.get("/api/user/admin", {
      params: { search, status }
    });
    setUsers(res.data || []);
  };

  useEffect(() => {
    load();
  }, [search, status]);

  const toggleStatus = async (id) => {
    await api.patch(`/api/user/admin/${id}/status`);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Deactivate this user?")) return;
    await api.delete(`/api/user/admin/${id}`);
    load();
  };

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">Users</h1>

      {/* FILTERS */}
      <div className="flex gap-4">
        <input
          placeholder="Search name or email"
          className="border px-3 py-2 rounded w-64"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          className="border px-3 py-2 rounded"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="blocked">Blocked</option>
        </select>
      </div>

      {/* USER LIST */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {users.map((u) => (
          <div
            key={u._id}
            className="border rounded-xl p-5 bg-white space-y-3"
          >
            <div>
              <h3 className="font-semibold">{u.name}</h3>
              <p className="text-sm text-gray-500">{u.email}</p>
            </div>

            <div className="flex gap-2 text-xs">
              <span className="px-2 py-1 rounded bg-gray-100">
                {u.role}
              </span>
              <span
                className={`px-2 py-1 rounded ${
                  u.isActive
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {u.isActive ? "Active" : "Blocked"}
              </span>
            </div>

            <div className="flex justify-between text-sm pt-2">
              <button
                onClick={() => setSelected(u)}
                className="text-blue-600"
              >
                View
              </button>

              <button
                onClick={() => toggleStatus(u._id)}
                className="text-indigo-600"
              >
                {u.isActive ? "Block" : "Activate"}
              </button>

              <button
                onClick={() => remove(u._id)}
                className="text-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* PROFILE MODAL */}
      {selected && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white rounded-xl p-6 w-full max-w-lg space-y-4">
            <h2 className="font-semibold">User Profile</h2>

            <p><b>Name:</b> {selected.name}</p>
            <p><b>Email:</b> {selected.email}</p>
            <p><b>Phone:</b> {selected.personalInfo?.phone}</p>
            <p><b>Current Role:</b> {selected.personalInfo?.currentRole}</p>
            <p><b>Experience:</b> {selected.personalInfo?.experienceLevel}</p>
            <p><b>Target:</b> {selected.personalInfo?.targetPosition}</p>

            <div className="text-right">
              <button
                onClick={() => setSelected(null)}
                className="text-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAdmin;
